import { Module } from 'vuex-smart-module';
import RepairsInfoActions from './actions';
import RepairsInfoGetters from './getters';
import RepairsInfoMutations from './mutations';
import RepairsInfoState from './state';

export default new Module({
  state: RepairsInfoState,
  mutations: RepairsInfoMutations,
  actions: RepairsInfoActions,
  getters: RepairsInfoGetters,
});
